import React from 'react'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'
import Collapse from '@material-ui/core/Collapse'

import {useStyles} from '../SideBarStyles.js'
import DynamicFeedIcon from '@material-ui/icons/DynamicFeed';
import IconExpandLess from "@material-ui/icons/ExpandLess";
import IconExpandMore from "@material-ui/icons/ExpandMore";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import {useHistory} from "react-router-dom";
import {Filters} from "../../../../utils/HelpFunctions";

function InitialSettings(props) {

    const {permissions, DataStore} = props

    const gtv = Filters(permissions, 'text', 'Gestión de tipos de vehículos')
    const grh = Filters(permissions, 'text', 'Gestión de rutas y horarios')
    const rc = Filters(permissions, 'text', 'Razones de cancelación')
    const rz = Filters(permissions, 'text', 'Restringir zonas')

    const classes = useStyles()
    const [open, setOpen] = React.useState(false)

    let history = useHistory();

    function handleClick() {
        setOpen(!open)
    }

    return (
        <List component="nav" className={classes.appMenu} disablePadding>
            <ListItem button onClick={handleClick} className={classes.menuItem}>
                <ListItemIcon className={classes.menuItemIcon}>
                    <DynamicFeedIcon/>
                </ListItemIcon>
                <ListItemText primary="Configuraciones" className={classes.menuItemText}/>
                {open ? <IconExpandLess className={classes.openSubMenuIcons}/> :
                    <IconExpandMore className={classes.openSubMenuIcons}/>}
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <Divider classes={{root: classes.divider}}/>
                <List>
                    {gtv[0].value && <ListItem button className={classes.nested}
                                               onClick={() => {
                                                   history.push("/control-panel/vehicle-type-management")
                                                   DataStore.getTabs('Gestión de tipos de vehículos')
                                               }}>
                        <FiberManualRecordIcon className={classes.fiberManualRecordIcon}/>
                        <ListItemText primary="Gestión de tipos de vehículos" className={classes.subItemsText}/>
                    </ListItem>}
                    {grh[0].value && <ListItem button className={classes.nested}
                                               onClick={() => {
                                                   history.push("/control-panel/create-routes-schedules")
                                                   DataStore.getTabs('Crear rutas y horarios')
                                               }}>
                        <FiberManualRecordIcon className={classes.fiberManualRecordIcon}/>
                        <ListItemText primary="Crear rutas y horarios" className={classes.subItemsText}/>
                    </ListItem>}

                    {rz[0].value && <ListItem button className={classes.nested}
                                              onClick={() => {
                                                  history.push("/control-panel/restrict-zones")
                                                  DataStore.getTabs('Restringir zonas')
                                              }}>
                        <FiberManualRecordIcon className={classes.fiberManualRecordIcon}/>
                        <ListItemText primary="Restringir zonas" className={classes.subItemsText}/>
                    </ListItem>}

                    {rc[0].value && <ListItem button className={classes.nested}
                                              onClick={() => {
                                                  history.push("/control-panel/cancellations")
                                                  DataStore.getTabs('Razones de cancelación')
                                              }}>
                        <FiberManualRecordIcon className={classes.fiberManualRecordIcon}/>
                        <ListItemText primary="Razones de cancelación" className={classes.subItemsText}/>
                    </ListItem>}
                </List>
                <Divider classes={{root: classes.divider}}/>
            </Collapse>
        </List>
    )

}

export default InitialSettings
